import { createApp } from '@app/adapters/create-app'

import ExternalCompanySelectorModal from '@app/application/company_links/components/external-company-selector-modal.vue'

export default (): void => {
  window.onDomLoad(function () {
    const liquidInputs = document.querySelectorAll(
      "[data-behaviour='external-account-selector-modal']"
    )
    if (liquidInputs?.length === 0) {
      return
    }

    const mountDiv = document.getElementById(
      'external-company-selector-modal'
    ) as HTMLElement

    if (!mountDiv) {
      return
    }

    const ledgerLabel = document.getElementById('ledger-label')?.innerHTML
    const currentUserId = window.Silverfin.currentUserId()

    createApp(ExternalCompanySelectorModal, {
      ledgerLabel,
      currentUserId,
    }).mount(mountDiv)
  })
}
